import React from 'react';
import { Criticidade, CRITICIDADE_COLORS } from '../../services/bugReportService';

interface Props {
  criticidade: Criticidade;
  size?: 'sm' | 'md';
}

const CRITICIDADE_LABEL: Record<Criticidade, string> = {
  BAIXA: 'Baixa',
  MEDIA: 'Media',
  ALTA: 'Alta',
  CRITICA: 'Critica',
};

export const CriticidadeBadge: React.FC<Props> = ({ criticidade, size = 'md' }) => {
  const c = CRITICIDADE_COLORS[criticidade];
  const sizeClass = size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-semibold uppercase tracking-wide ${c.bg} ${c.text} ${c.border} ${sizeClass}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${c.dot}`} />
      {CRITICIDADE_LABEL[criticidade]}
    </span>
  );
};
